import { render, staticRenderFns } from "./AttachmentRow.vue?vue&type=template&id=1e4f4163&"
import script from "./AttachmentRow.vue?vue&type=script&lang=js&"
export * from "./AttachmentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports